const GettingStartedPage = () =>
  import(/* webpackChunkName: "gds-getting-started-page" */ './pages/GettingStartedPage');

export const gdsRoute = [
  {
    path: '/gds/gettingstarted',
    name: 'gdsgettingstarted',
    component: GettingStartedPage,
  },
];
